import Swiper from "swiper";
import swiperSettings from './swiper-settings';

export default function() {
  document.addEventListener('DOMContentLoaded', () => {

    let swiperContainer = document.querySelector('.category-swiper')

    if(!swiperContainer){
      return;
    }

    function categorySwiper() {

      const swiper = new Swiper(swiperContainer, {
        ...swiperSettings,
        breakpoints: {
          768: {
            spaceBetween: 0,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            enabled: false,
          },
        }
      })
      swiper.init()
    }

    categorySwiper()
  })
}
